//import thu vien react
import { useEffect, useState,useContext } from "react";
import { createFilter } from 'react-select';
import WindowedSelect from "react-windowed-select";

//import để sử dụng phần state toàn cục
import Context from '../../Store/Context';

//import phần translate
import { useTranslation } from "react-i18next";

//import toast
import {toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import component
import Pagination from '../Pagination/Pagination';
import CoinTableItemCpn from "./CoinTableItemCpn";

//phần call api
import ApiNameCoinGecko from "../../Api/ApiNameCoinGecko.json";
import apiClientCoinGecko from "../../Api/ApiClientCoinGecko";


import { callAPiCoinMarket } from './../../CallApi/CallApiCoinMarkets';

import  './CoinTable.css';

function CurrencyTableCpn(){

 //phần translate
 const { t } = useTranslation("translation");
    
 //phần state toàn cục
 const [state,dispatch] = useContext(Context);
 //lấy ra currency chọn ở header
 const {currency} = state;

 //data hien thi theo filterName
 const [arrDataFilter,setArrDataFilter] = useState([]);

 //data gọi từ api coin/list
 const [arrCoinList,setArrCoinList] = useState([]);

 //loading khi gọi api
 const [loading,setLoading] = useState(true);

 //phần phân trang
 //page hiển thị hiện tại
 const [currentPage, setCurrentPage] = useState(1);
 //số lượng phần tử trên 1 page
 const [pageSize,setPageSize] = useState(10);
 //kích thước mảng để phân trang
 const [totalCount,setTotalCount] = useState(0);

 const [arrSearch,setArrSearch] = useState([]);

//  useEffect(()=>{  
//      callApiPromise();
//  },[currency])

 useEffect(()=>{  
    callApiPromise();
},[])


 //ids dùng trong trường hợp filter theo name
 //perpage là số lượng item trong 1 trang
 //page là page hiện tại đang được chọn
 //api dùng để hiển thị coin ở table
  const apiCoinMarketIds = (ids="",perPage=null,page=null)=>{
    if(loading===false)
        setLoading(true);
    callAPiCoinMarket({
        "vs_currency":currency,
        "ids":ids,
        "per_page":perPage,
        "page":page
    })
    .then((res)=>{
        const {data=[]} = res;
        setArrDataFilter(data);
      
        if(ids){
            setTotalCount(data.length);
        }
    })
    .catch(()=>{
        toast.error("Error Network");
    })
    .finally(()=>{
        setLoading(false);
    })
  }

 const apiCoinMarket = ()=>{
    // return callAPiCoinMarket({
    //     "vs_currency":currency,
    //     "per_page":pageSize,
    //     "page":currentPage   
    // })

    return callAPiCoinMarket({
        "vs_currency":currency,
        "per_page":250,
        "page":1   
    })
 }

 const buildDataCoinMarket = (res=[])=>{
    setArrDataFilter(res.slice(0,10));
    setArrSearch(res);
 }


 const apiCoinList = ()=>{
        return apiClientCoinGecko.get(ApiNameCoinGecko.coin_list);
}



 const buildDataApiCoinList = (res=[])=>{
       setTotalCount(res.length);
       setArrCoinList(res);

 
 }

 const callApiPromise = ()=>{
    Promise.all([apiCoinList(),apiCoinMarket()])
    .then(res=>{ 
        const [resCoinList,resCoinMarket] = res;
        
        buildDataApiCoinList(resCoinList.data);
        buildDataCoinMarket(resCoinMarket.data);
    })
    .catch(err=>{
        toast.error("Api Error");
    })
    .finally(()=>{
        setLoading(false);
    })
 }

   //khi nhấn chuyển sang trang mới
    const currentTableData = (page) =>{
    //  callApiCoinMarket(pageSize,page);
     apiCoinMarketIds("",pageSize,page);
     setCurrentPage(page);

     window.scrollTo(0,0);
   }

  //khi chọn lại số lượng phần tử hiển thị trên 1 trang
 const onchangePageZie = (e) =>{
    const value = parseInt(e.target.value);
    if(value !== pageSize)
    {
       setCurrentPage(1);
       setPageSize(value);
    //    callApiCoinMarket(value,1)
       apiCoinMarketIds("",value,1);
    }

 }
    //phan search theo name
    const handleSearch = (e=[])=> {
        setCurrentPage(1);
        if(e.length===0){

            setTotalCount(arrCoinList.length);
            // callApiCoinMarket(pageSize,1);
            apiCoinMarketIds("",pageSize,1);
        }
        else{
           
            let arrTemp = [];
            e.forEach((item,index)=>{
                const {id=""} = item;
                arrTemp.push(id);
            })

            if(arrTemp.length>0){
                // callApiCoinMarketIds(arrTemp.join());
                apiCoinMarketIds(arrTemp.join());
            }

        }
    };



    const getTheme = ()=>{
        let temp =window.localStorage.getItem("theme");
        if(!temp || temp === "light")
         return "text-muted thead-light";
         
        else
         return "text-muted thead-dark";
           
     }

     const getThemeTable = ()=>{
        let temp =window.localStorage.getItem("theme");
        if(!temp || temp === "light")
         return "table table-crypto";
         
        else
         return "table table-crypto";
           
     }

    return (
        <>
            <div className={loading===true ? "loader":""} />

            {/* phần select pageSize và searchName */}
            <div className="row">
                <div className="col-sm-12 col-md-6">
                    <div className="dataTables_length text-center text-md-start mt-2 mb-3" id="alternative-pagination_length">
                    <label style={{fontSize:"14px"}}>
                        Hiển thi{" "}
                        <select
                        className="form-select form-select-sm d-inline-block w-auto"
                        style={{paddingTop:"0.15rem",paddingBottom:"0.15rem"}}                       
                        onChange={onchangePageZie}
                        >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        </select>
                        {" "}Mục
                    </label>
                    </div>
                </div>
                <div className="col-sm-12 col-md-6">
                    <div id="alternative-pagination_filter" className="text-center text-sm-end mb-3">
                    <label style={{fontSize:"14px",width:"50%",color:"black"}}>
                        <WindowedSelect
                            id="search2"
                            options={arrSearch.map(item=>({...item,label:item.name + "("+item.symbol.toUpperCase() + ")",value:item.id}))}//bắt buộc phải có label và value
                            //label là cái để show ra bên ngoài
                            //value là cái để phân biệt sau khi chọn xong,thường là id


                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 0,
                                colors: {
                                ...theme.colors,
                                  text: 'red',
                                  primary25: 'rgb(245, 245, 245)',
                                  dangerLight:'red'
                               
                                },
                              })}
                            
                            isMulti={true}
                            onChange={handleSearch}
                            filterOption={createFilter({ignoreAccents: false})}
                            placeholder="Tìm kiếm theo tên"   
                            // onInputChange={handleFilterName}                          
                        />
                    </label>
                    </div>
                </div>
            </div>


            {/* phần table */}
            <div className="row">
                <div className="table-responsive">
                    <table className={getThemeTable()}>
                        <thead className={getTheme()}>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col" style={{ textAlign: "left" }}>
                                    {t("Coin")}
                                </th>
                                <th scope="col">Gía</th>
                                <th scope="col">1h</th>
                                <th scope="col">24h</th>
                                <th scope="col">7d</th>
                                <th scope="col">KL GD trong 24H </th>
                                <th scope="col">Giá vốn hóa TT</th>
                                {/* <th scope="col">{t("Market_Cap/FDV")}</th> */}
                                <th scope="col">7 ngày qua</th>
                            </tr>
                        </thead>

                        <tbody style={{verticalAlign:"middle",color:"var(--color-primary)"}}>                                
                            {
                                arrDataFilter.map((item,index)=><CoinTableItemCpn key={index} dataItem={item} dataIndex={((currentPage-1)*pageSize + index)} />)
                            } 
                        </tbody>
                    </table>
                </div>
            </div>

            {/* phần phân trang */}
            <div className="row gy-3">

                <div className="col-sm-12 col-md-5">
                    <div className="text-center text-md-start mt-2 mb-3" style={{fontSize:"15px"}}>
                        Hiển thị {(currentPage-1)*pageSize + 1} đến {(currentPage-1)*pageSize + pageSize} trong {totalCount} kết quả
                    </div>                            
                </div>
                <div className="col-sm-12 col-md-7">
                    <Pagination
                        className="pagination-bar mt-2 mb-3"
                        currentPage={currentPage}
                        totalCount={totalCount}
                        pageSize={pageSize}
                        onPageChange={currentTableData}
                    />
                </div>

                
            </div>
        </>
    )

}

export default CurrencyTableCpn;